import React, { PropTypes } from 'react';
import FullControl from './FullControl';
import CondensedButton from './CondensedButton';

export default class MapControl extends React.Component {

	constructor(props) {
		super(props);
		this.state = { showControl: true };
	}

	handleCondensedClick() {
		this.setState({showControl: true});
	}

	handleHideControl() {
		this.setState({showControl: false});
	}

	render () {
		return this.state.showControl 
			? <FullControl
				onAddShape={this.props.onAddShape}
				onRemoveShape={this.props.onRemoveShape} 
				filter={this.props.filter}
				layers={this.props.layers}
				getMapLayers={this.props.getMapLayers}
				changeOneMapLayer={this.props.changeOneMapLayer}
				isFetchingMapLayers={this.props.isFetchingMapLayers}
				maplayers={this.props.maplayers}
				addLayer={this.props.addLayer}
				removeLayer={this.props.removeLayer}
				moveLayer={this.props.moveLayer}
				resetLayers={this.props.resetLayers}
				zoomToLayer={this.props.zoomToLayer}
				getMapLayerCapabilities={this.props.getMapLayerCapabilities}
				setShowLegend={this.props.setShowLegend}
				showLegend={this.props.showLegend}
				shapes={this.props.shapes}
				setSectors={this.props.setSectors}		
				setLocalities={this.props.setLocalities}				
				setSamplingPoints={this.props.setSamplingPoints}				
				setKeywords={this.props.setKeywords}
				keywords={this.props.keywords} 
				onHide={this.handleHideControl.bind(this)}
				projects={this.props.projects} 
				isGisOnly={this.props.isGisOnly}
				isGisAdmin={this.props.isGisAdmin} /> 
			: <CondensedButton
				tooltip="Mostrar Filtro" 
				className="map-condensed-button" 
				onClick={this.handleCondensedClick.bind(this)} />; 
	}
}

MapControl.propTypes = {
	onAddShape: PropTypes.func.isRequired,
	onRemoveShape: PropTypes.func.isRequired,
	shapes: PropTypes.object.isRequired,
	setSectors: PropTypes.func.isRequired,		
	addLayer: PropTypes.func.isRequired,
	removeLayer: PropTypes.func.isRequired,
	moveLayer: PropTypes.func.isRequired,
	resetLayers: PropTypes.func.isRequired,
	zoomToLayer: PropTypes.func.isRequired,
	getMapLayerCapabilities: PropTypes.func.isRequired,
	setShowLegend: PropTypes.func.isRequired,
	showLegend: PropTypes.bool.isRequired,
	setLocalities: PropTypes.func.isRequired,		
	setSamplingPoints: PropTypes.func.isRequired,		
	setKeywords: PropTypes.func.isRequired,	
	keywords: PropTypes.array.isRequired,
	layers: PropTypes.array.isRequired,
	getMapLayers: PropTypes.func.isRequired,
	changeOneMapLayer: PropTypes.func.isRequired,
	maplayers: PropTypes.array.isRequired,
	isFetchingMapLayers: PropTypes.bool.isRequired,
	filter: PropTypes.object.isRequired,
	projects: PropTypes.object.isRequired,
	isGisOnly: PropTypes.bool.isRequired,
	isGisAdmin: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/MapControl.js